angular.module("UI8.components").component("appFooter", {
  template: `
    <footer class="footer" ng-hide="$ctrl.hidden">
      <div class="footer__top-border"></div>
      <div id="footer-nlcard-bg" class="footer__shader"></div>
      <div class="footer__nlcard">
        <div class="footer__nlcard-inner">
          <a class="footer__logo" href="/"></a>
          <div class="footer__nlcard-text">
            <p class="footer__nlcard-title">Stay in the loop</p>
            <p class="footer__nlcard-sub">Discounts, new drops, design inspiration — weekly.</p>
          </div>
          <div class="footer__nlcard-input">
            <div class="nl-input nl-input--footer">
              <div id="nl-border-footer" class="nl-input__border"></div>
              <span id="nl-placeholder-footer" class="nl-input__placeholder">Enter your email</span>
              <input id="nl-field-footer" type="text" inputmode="email" maxlength="50" placeholder=" " autocomplete="one-time-code" data-1p-ignore data-lpignore="true" data-form-type="other">
              <span id="nl-status-footer" class="nl-input__status"></span>
              <div id="nl-indicator-footer" class="nl-input__indicator"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer__inner">
        <div class="footer__row">
          <div class="footer__col--browse">
            <p class="footer__title">Browse</p>
            <nav class="footer__nav footer__nav--grid">
              <a class="footer__link" href="/category/ui-kits">UI Kits</a>
              <a class="footer__link" href="/category/coded-templates">Coded Templates</a>
              <a class="footer__link" href="/category/wireframe-kits">Wireframe kits</a>
              <a class="footer__link" href="/category/illustrations">Illustrations</a>
              <a class="footer__link" href="/category/themes">Templates</a>
              <a class="footer__link" href="/category/presentation">Presentation</a>
              <a class="footer__link" href="/category/mockups">Mockups</a>
              <a class="footer__link" href="/category/3d-assets">3D Assets</a>
              <a class="footer__link" href="/category/icons">Icon Sets</a>
              <a class="footer__link" href="/category/fonts">Fonts</a>
              <a class="footer__link" href="/categories/figma">Figma</a>
              <a class="footer__link" href="/categories/sketch">Sketch</a>
              <a class="footer__link" href="/tags/framer">Framer</a>
              <a class="footer__link" href="/category/freebies">Freebies</a>
            </nav>
          </div>
          <div class="footer__col--platform">
            <p class="footer__title">Platform</p>
            <nav class="footer__nav">
              <a class="footer__link" href="/products/all-access-pass">All Access Pass</a>
              <a class="footer__link" href="https://ui8.ai/forge" target="_blank">Forge<span class="new"><span class="new__label">New</span></span></a>
              <a class="footer__link" href="https://clap.io/" target="_blank">Clap<span class="new"><span class="new__label">New</span></span></a>
              <a class="footer__link" href="/authors">Become an author</a>
              <a class="footer__link" href="/affiliates">Affiliate program</a>
            </nav>
          </div>
          <div class="footer__col--connect">
            <p class="footer__title">Connect</p>
            <div class="footer__social">
              <a class="footer__social-link" href="mailto:info@ui8.net" aria-label="Email">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M1.5 8.67v8.58a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3V8.67l-8.928 5.493a3 3 0 0 1-3.144 0L1.5 8.67Z"/><path d="M22.5 6.908V6.75a3 3 0 0 0-3-3h-15a3 3 0 0 0-3 3v.158l9.714 5.978a1.5 1.5 0 0 0 1.572 0L22.5 6.908Z"/></svg>
              </a>
              <a class="footer__social-link" href="https://instagram.com/ui8net" target="_blank" aria-label="Instagram">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M7.877 2.06L12 2l4.118.06a7.37 7.37 0 0 1 2.427.465c.665.256 1.27.649 1.774 1.153s.898 1.108 1.156 1.773a7.37 7.37 0 0 1 .465 2.427L22 12l-.06 4.118a7.37 7.37 0 0 1-.465 2.427c-.256.665-.649 1.27-1.153 1.774s-1.108.898-1.773 1.156a7.37 7.37 0 0 1-2.427.465L12 22c-2.715 0-3.056-.012-4.118-.06a7.37 7.37 0 0 1-2.427-.465c-.665-.256-1.27-.649-1.774-1.153s-.898-1.108-1.156-1.773a7.37 7.37 0 0 1-.465-2.427L2 12l.06-4.118a7.37 7.37 0 0 1 .465-2.427c.256-.665.649-1.27 1.153-1.774s1.108-.898 1.773-1.156a7.37 7.37 0 0 1 2.427-.465zm4.123 4.805c-1.016 0-2.009.301-2.853.865s-1.503 1.366-1.891 2.305-.49 1.971-.292 2.967.687 1.911 1.405 2.63 1.633 1.207 2.629 1.405 2.029.096 2.967-.292 1.74-1.047 2.305-1.891.866-1.837.866-2.853c0-1.362-.541-2.668-1.504-3.631s-2.269-1.504-3.631-1.504zm0 8.469c-.659 0-1.304-.196-1.852-.562s-.975-.887-1.228-1.496-.318-1.279-.19-1.926.446-1.241.912-1.707 1.06-.784 1.707-.912 1.317-.063 1.926.19 1.13.68 1.496 1.228.562 1.193.562 1.852c0 .884-.351 1.732-.976 2.357s-1.473.976-2.357.976zm6.533-8.672a1.2 1.2 0 0 1-2.4 0 1.2 1.2 0 0 1 2.4 0z"/></svg>
              </a>
              <a class="footer__social-link" href="https://x.com/ui8" target="_blank" aria-label="X">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M13.89 10.464 21.173 2h-1.725l-6.323 7.35L8.074 2H2.25l7.636 11.114L2.25 21.99h1.726l6.676-7.762 5.333 7.762h5.825zm-2.363 2.748-.773-1.107-6.157-8.806h2.65l4.969 7.107.774 1.106 6.458 9.238h-2.65z"/></svg>
              </a>
              <a class="footer__social-link" href="javascript:window.$chatwoot && window.$chatwoot.toggle('open')" aria-label="Messages">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M1.5 12c0-5.145 4.893-9 10.5-9s10.5 3.855 10.5 9-4.893 9-10.5 9q-.953 0-1.861-.141a10.46 10.46 0 0 1-4.59 1.59 1.125 1.125 0 0 1-1.07-1.71 5.2 5.2 0 0 0 .704-1.89C2.969 17.229 1.5 14.79 1.5 12"/></svg>
              </a>
            </div>
          </div>
        </div>
        <div class="footer__bottom">
          <p class="footer__copy">
            © 2026, Robot Global FZCO / UI8.NET
            <span class="footer__dot"></span>
            <a class="footer__legal-link" href="/terms">Terms &amp; Licensing</a>
            <a class="footer__legal-link" href="/privacy-policy">Privacy Policy</a>
          </p>
        </div>
      </div>
    </footer>
  `,

  controller: [
    "$location",
    "$rootScope",
    function ($location, $rootScope) {
      var ctrl = this;

      // Pages that land straight into content — no footer there. The hire
      // inbox (UI8-16) is an app-like view; a marketing footer under a
      // conversation reads as clutter.
      var HIDE_FOOTER_ON = ["/account/purchases", "/account/inbox"];

      function updateHidden() {
        var path = $location.path();
        ctrl.hidden = HIDE_FOOTER_ON.some(function (prefix) {
          return path.indexOf(prefix) === 0;
        });
      }
      updateHidden();
      $rootScope.$on("$locationChangeSuccess", updateHidden);

      ctrl.$postLink = function () {
        function initFooter() {
          function mountFooterBg() {
            var PS = window.PaperShaders;
            if (!PS || !PS.godRaysFragmentShader) return;
            if (!window.PaperShadersUtils.webglSupported()) return;
            var noiseImg = PS.getShaderNoiseTexture();
            function create() {
              new PS.ShaderMount(
                document.getElementById("footer-nlcard-bg"),
                PS.godRaysFragmentShader,
                {
                  u_colorBack: PS.getShaderColorFromString("#121214"),
                  u_colorBloom: PS.getShaderColorFromString("#2a1c0c"),
                  u_colors: ["#000000", "#0c1c40f0", "#2a1a0a", "#1a0a2a"].map(
                    PS.getShaderColorFromString
                  ),
                  u_colorsCount: 4,
                  u_bloom: 1.0,
                  u_intensity: 0.19,
                  u_density: 0.02,
                  u_spotty: 1.0,
                  u_midSize: 0.2,
                  u_midIntensity: 0.5,
                  u_noiseTexture: noiseImg,
                  u_fit: 0,
                  u_rotation: 28,
                  u_scale: 2.92,
                  u_offsetX: -0.4,
                  u_offsetY: 1.0,
                  u_originX: 0.5,
                  u_originY: 0.5,
                  u_worldWidth: 0,
                  u_worldHeight: 0,
                },
                undefined,
                2.0,
                0,
                2,
                // god rays are soft — cap the canvas at ~0.8MP and let the
                // GPU upscale; indistinguishable behind content, 3-4x cheaper
                800000
              );
            }
            if (noiseImg && noiseImg.complete) create();
            else if (noiseImg) noiseImg.onload = create;
            else create();

            // Pause when scrolled out of view, resume when back
            var bgEl = document.getElementById("footer-nlcard-bg");
            new IntersectionObserver(
              function (entries) {
                var mount = bgEl && bgEl.paperShaderMount;
                if (!mount) return;
                if (entries[0].isIntersecting) mount.setSpeed(2.0);
                else mount.setSpeed(0);
              },
              { rootMargin: "200px" }
            ).observe(bgEl);
          }

          if (window.PaperShaders) {
            mountFooterBg();
          } else {
            window.addEventListener("paper-shaders-ready", mountFooterBg, {
              once: true,
            });
            // three.js + paper-shaders load on demand; the footer is in
            // (or near) view by the time initFooter runs, so ask now
            if (window.PaperShadersUtils) window.PaperShadersUtils.requestShaders();
          }

          if (window.Newsletter) {
            window.Newsletter.initNewsletterBorder(
              document.getElementById("nl-border-footer")
            );
            window.Newsletter.initNewsletterInput(
              "nl-field-footer",
              "nl-placeholder-footer",
              "nl-status-footer",
              "nl-indicator-footer"
            );
          }
        }

        var footerEl = document.querySelector(".footer");
        if (!footerEl) {
          initFooter();
          return;
        }
        var obs = new IntersectionObserver(
          function (entries) {
            if (!entries[0].isIntersecting) return;
            obs.disconnect();
            initFooter();
          },
          { rootMargin: "200px" }
        );
        obs.observe(footerEl);
      };
    },
  ],
});
